<template>
  <div class="animated fadeIn">
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="6">
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Not Authorized</h1>
                <b-button type="button" variant="primary" class="px-4" @click="logout">Logout</b-button>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import {logout} from '@/services/auth'

export default {
  methods: {
    logout () {
      logout()
        .then(response => {
          this.$router.replace({ path: '/login' })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/NotAuthorized.vue